// extracted by mini-css-extract-plugin
module.exports = {"header":"infoStop_header__3cr2y","div":"infoStop_div__2F6Iv","link":"infoStop_link__2ACi6","lines":"infoStop_lines__zZQ1h","time":"infoStop_time__1YgqL"};